export const USERIDENTIFIERSUBTYPES = [
    'Line_ID',
    'Facebook_ID',
    'GAID',
    'IDFA',
    'CDS_PIXEL_COOKIE'];


// WEBPACK FOOTER //
// ./src/app/services/constants/user-identifier-sub-type-list.ts